import { render, staticRenderFns } from "./AdminContinueHoliday.vue?vue&type=template&id=597112f6&scoped=true&"
import script from "./AdminContinueHoliday.vue?vue&type=script&lang=js&"
export * from "./AdminContinueHoliday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597112f6",
  null
  
)

export default component.exports